var CommResultItem = React.createClass({
  propTypes: {
    hit: React.PropTypes.object.isRequired,
    showIcon: React.PropTypes.bool,
    showAuthor: React.PropTypes.bool,
    showCommunityPath: React.PropTypes.bool,
    showAnswerStatus: React.PropTypes.bool,
    showReplyCount: React.PropTypes.bool,
    showDate: React.PropTypes.bool,
    size: React.PropTypes.oneOf(["sm", ""])
  },
  getDefaultProps() {
    return {
      showIcon: true,
      showAuthor: true,
      showCommunityPath: true,
      showAnswerStatus: true,
      showReplyCount: true,
      showDate: true,
      size: ""
    }
  },
  getReplyCount() {
    let count = this.props.hit.discussion.answerCount;
    let label = Labels.getLabel("replies");
    let className = "";

    if (count == 0) {
      className = "text-danger";
    } else if (count == 1) {
      label = Labels.getLabel("reply");
    }

    return <span className={className}>{count} {label}</span>;
  },
  getAnswerStatus() {
    if (this.props.hit.discussion.answered) {
      return <span className="text-success"><span className="glyphicon glyphicon-ok"></span> {Labels.getLabel("Answered")}</span>;
    } else {
      return <span><span className="glyphicon glyphicon-question-sign"></span> {Labels.getLabel("Unanswered")}</span>
    }
  },
  getDate() {
    let discussion = this.props.hit.discussion;
    let date, label;

    if (discussion.answerCount > 0) {
      label = Labels.getLabel("Last reply");
      date = discussion.lastReplyDateDisplay;
    } else {
      label = Labels.getLabel("Asked");
      date = discussion.askedDateDisplay;
    }

    return <span>{`${label} ${date}`}</span>;
  },
  getAuthor() {
    let {hit} = this.props;
    let profileText = hit.member.initials;
    let isUserActive = hit.member.active && !hit.member.archived;
    let avatarPath = Config.contextPath + RA.defaultAvatar(isUserActive ? hit.member.avatar : '');
    console.log("Is User Active" + isUserActive);

    return <span>
    {Labels.getLabel("By")}{" "}
      <span className="user-image -xs">
        {RA.Utils.isNotBlank(this.props.hit.member.avatar) && isUserActive ? (
          <img src={avatarPath} alt="" className="user-image__avatar" />
        ) : profileText && isUserActive? (
          <div className="profile-section-avatar-text user-avatar-size">{profileText}</div>
        ) : (
          <img src={avatarPath} alt="" className="user-image__avatar" />
        )}
      </span>
    {" " + hit.member.username}
  </span>
  },
  getCommunityPath() {
    let hit = this.props.hit;
    let communityUrl = `${Config.contextPath}/${Config.portalInterface}/?tabname=community&communityID=${hit.community.id}`;
    let topicUrl = `${Config.contextPath}/${Config.portalInterface}/?tabname=community&communityID=${hit.community.id}&topicID=${hit.topic.id}`;

    return (
      <span>
        in <span className="view-link__path"><a href={communityUrl}>{hit.community.name}</a> &gt; <a href={topicUrl}>{hit.topic.name}</a></span></span>
    )
  },
  renderLine1() {
    let {
      showAuthor,
      showCommunityPath
    } = this.props;

    if (!showAuthor && !showCommunityPath) return;

    let author, communityPath;
    if (showAuthor) author = this.getAuthor();
    if (showCommunityPath) communityPath = this.getCommunityPath();

    return (
      <div className="view-link__sub-line">
        {author}
        {" "}{communityPath}
      </div>
    )
  },
  renderLine2() {
    let {
      showAnswerStatus,
      showReplyCount,
      showDate
    } = this.props;

    if (!showAnswerStatus && !showReplyCount && !showDate) return;

    let answerStatus, replyCount, date;
    if (showAnswerStatus) answerStatus = this.getAnswerStatus();
    if (showReplyCount) replyCount = this.getReplyCount();
    if (showDate) date = this.getDate();

    return (
      <ChildDelimited className="view-link__sub-line">
        {answerStatus}
        {replyCount}
        {date}
      </ChildDelimited>
    )
  },
  renderIcon() {
    if (this.props.showIcon) {
      let hit = this.props.hit;

      return (
        <div className={"view-link__icon " + (hit.discussion.answered ? "-success" : "-muted")}>
          <i className="glyphicon glyphicon-comment"></i>
        </div>
      )
    }
  },
  openLink(e) {
	let {hit, size } = this.props;
    let viewUrl = `${Config.contextPath}/controller/view/discussion/${hit.discussion.id}?` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;

	if (launchLinksInNewWindow) {
		e.preventDefault();
		RA.Utils.openCenteredWindow(viewUrl, '1100', '800');
	}
  },
  render() {
    let {
      hit,
      size
    } = this.props;
    let viewUrl = `${Config.contextPath}/controller/view/discussion/${hit.discussion.id}?` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
    let className = classNames("view-link",  {[`-${size}`]: size.length});


    return (
      <li className={className}>
        {this.renderIcon()}
        <div className={this.props.showIcon ? "view-link__content" : ""}>
          <a onClick={this.openLink} href={viewUrl} className="view-link__title">{hit.discussion.title}</a>
          <div className="view-link__subhead">
            {this.renderLine1()}
            {this.renderLine2()}
          </div>
        </div>
      </li>
    )
  }
})